/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFxReveal = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M13 3.7V2h2v1.7h4.143v2H15V10h2c2.255 0 4 1.905 4 4.15s-1.746 4.15-4 4.15h-2V20h-2v-1.7h-2v-2h2V12h-2c-2.255 0-4-1.905-4-4.15S8.745 3.7 11 3.7zm0 2h-2c-1.06 0-2 .916-2 2.15S9.94 10 11 10h2zm2 6.3v4.3h2c1.06 0 2-.916 2-2.15S18.06 12 17 12zm-9-.302 3.64 3.034-1.28 1.536L6 14.302l-2.36 1.966-1.28-1.536zm0 8-2.36-1.966-1.28 1.536L6 22.302l3.64-3.034-1.28-1.536z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFxReveal as FxReveal };
